export default {"src":"/_next/static/media/logo-facebook.cf481a58.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};